// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f2fa3afe","977":"e1bd0786"}[chunkId] + ".chunk.js";
};